// extracted by mini-css-extract-plugin
export default {"img":"customer_photo_img__pnjyC","nameImg":"customer_photo_nameImg__cXVHn"};